import { Select as AntdSelect } from 'antd';
import { defaultProps, SelectProps, selectWidthMap } from './Select.type';
import styles from "./Select.module.scss";

export const Select = (props: SelectProps) => {
  const { ...attributes } = { ...defaultProps, ...props };

  const style = {
    width: selectWidthMap[attributes.width],
  }

  return (
    <AntdSelect
      {...attributes}
      className={styles.Select}
      style={style}
    />
  );
};
